import { useState } from 'react'
import { useHistory } from 'react-router'
import useOnPremAgentClient from '~/api/OnPremAgentClient/useOnPremAgentClient'
import { InstrumentType } from '~/api/onPremAgent/dataIngestorsAPI'
import Button from '~/components/buttons/Button'
import Input from '~/components/Input'
import AddIcon from '~/components/icons/AddIcon'
import { StructuredDataFormData } from '~/components/StructuredDataForm/StructuredDataForm'
import Toaster from '~/components/Toaster'
import OnPremAgentBreadcrumbs from '../components/OnPremAgentBreadcrumbs'
import DataIngestorConfigForm from './DataIngestorConfigForm'
import DataIngestorInstrumentSelect from './DataIngestorInstrumentSelect'
import cs from './data_ingestors_create.scss'

export default function DataIngestorsCreate() {
  const [instrumentName, setInstrumentName] = useState('')
  const [instrumentType, setInstrumentType] = useState<InstrumentType | null>(null)
  const [configValues, setConfigValues] = useState<StructuredDataFormData>({})
  const client = useOnPremAgentClient()
  const history = useHistory()
  const [createInProgress, setCreateInProgress] = useState(false)

  const isDataValid = () => instrumentType != null

  const createDataIngestor = async () => {
    setCreateInProgress(true)
    try {
      if (instrumentType == null) {
        throw new Error('Instrument type must be selected.')
      }
      await client.dataIngestors.createDataIngestor(instrumentName, {
        instrument_type: instrumentType,
        config: configValues,
      })
      setCreateInProgress(false)
      Toaster.show({
        message: `Successfully created data ingestor CYTATION_001`,
        intent: 'success',
      })
      history.push('/data-ingestors')
    } catch (_e) {
      Toaster.show({
        message: 'Failed to create data ingestor.',
        intent: 'danger',
      })
    }
  }

  return (
    <div className={cs.dataIngestorsList}>
      <div className={cs.topBar}>
        <div className={cs.controls}>
          <OnPremAgentBreadcrumbs isCreatePage />
          <div className={cs.spacer} />

          <Button
            type='primary'
            label='Create Data Ingestor'
            onClick={createDataIngestor}
            className={cs.button}
            IconComponent={AddIcon}
            disabled={!isDataValid() || createInProgress}
          />
        </div>
      </div>
      <div className={cs.instrumentForm}>
        <div className={cs.sectionTitle}>Select Instrument</div>
        <div className={cs.field}>
          <div className={cs.name}>Instrument Type</div>
          <div className={cs.value}>
            <DataIngestorInstrumentSelect
              className={cs.select}
              selectedInstrument={instrumentType}
              onInstrumentSelect={setInstrumentType}
            />
          </div>
        </div>
        <div className={cs.field}>
          <div className={cs.name}>Instrument Name</div>
          <div className={cs.value}>
            <Input
              inputClassName={cs.input}
              value={instrumentName ? instrumentName : ''}
              onChange={setInstrumentName}
            />
          </div>
        </div>
        {instrumentType !== null && (
          <div className={cs.configFormSection}>
            <div className={cs.sectionTitle}>Configure Settings</div>
            <DataIngestorConfigForm
              className={cs.configForm}
              instrumentType={instrumentType}
              configValues={configValues}
              setConfigValues={setConfigValues}
            />
          </div>
        )}
      </div>
    </div>
  )
}
